import type {
  Ability,
  CharacterStats,
  MovementStats,
} from '../../CharacterTypes';

export const PALADIN_CONFIG = {
  name: 'Dawnward',
  description: 'Holy warrior with healing powers and defensive abilities',
  baseStats: {
    strength: 13,
    dexterity: 9,
    intelligence: 11,
    luck: 12,
    attack: 13,
    magicAttack: 10,
    defense: 12,
    magicDefense: 12,
    criticalRate: 0.06
  } as CharacterStats,
  healthMultiplier: 1.1,
  manaMultiplier: 1.1,
  color: '#FFD700',
  movementStats: {
    jumpPower: 1000,
    targetJumpHeight: 200,
    moveSpeed: 260,
    gravityScale: 1.1,
    terminalVelocity: 1200,
    acceleration: 2500,
    deceleration: 6000
  } as MovementStats,
  abilities: [
    {
      id: 'paladin_auto',
      name: 'Holy Strike',
      damage: 14,
      manaCost: 0,
      cooldown: 700,
      lastUsed: 0,
      range: 90,
      castTime: 0,
      description: 'Basic holy melee attack.',
      icon: '/icons/holy_strike.svg'
    },
    {
      id: 'holy_strike',
      name: 'Holy Strike',
      damage: 16,
      manaCost: 8,
      cooldown: 600,
      lastUsed: 0,
      range: 100,
      castTime: 0,
      description: 'Melee attack with holy damage',
      icon: '/icons/holy_strike.svg'
    },
    {
      id: 'hammer_throw',
      name: 'Hammer Throw',
      damage: 25,
      manaCost: 20,
      cooldown: 5000,
      lastUsed: 0,
      range: 400,
      castTime: 0,
      description: 'Throw a magical hammer in an arc',
      icon: '/icons/hammer_throw.svg'
    },
    {
      id: 'divine_shield',
      name: 'Divine Shield',
      damage: 0,
      manaCost: 30,
      cooldown: 30000,
      lastUsed: 0,
      range: 0,
      castTime: 0,
      description: 'Become immune to damage for 8 seconds',
      icon: '/icons/divine_shield.svg'
    },
    {
      id: 'consecration',
      name: 'Consecration',
      damage: 30,
      manaCost: 25,
      cooldown: 20000,
      lastUsed: 0,
      range: 120,
      castTime: 1500,
      description: 'Holy ground damages nearby enemies',
      icon: '/icons/consecration.svg'
    }
  ] as Ability[]
};
